import { useMutation, useQuery } from 'react-query'
import { useProductsService } from 'services/productsService'
import { useWheatCodesService } from 'services'
import { TProduct } from 'types'
import { Entity } from 'utils/hooks'
import { ProductsModuleAdapter } from '../types/shared.types'

export const wheatProductsAdapter: ProductsModuleAdapter = {
  moduleKey: 'wheat',
  headerTitle: 'Blending Spec',
  addButtonText: 'Add Blending Spec',
  tableKey: 'blendingSpec',
  labels: {
    nameColumn: 'Name',
    deleteConfirmTitle: 'Are you sure you want to remove this Blending Spec?',
    loadingText: 'Loading...',
  },
  toasts: {
    created: 'Blending Spec created',
    updated: 'Blending Spec updated',
    deleted: 'Blending Spec deleted successfully',
    deleteFailed: 'Blending Spec cannot be deleted',
    updateFailed: 'An error occurred while updating blending spec',
  },
  invalidatQueryName: 'products_list',
  permissionEntity: Entity.PRODUCT,

  useDefaultAttributes() {
    const { getWheatCodeAttributes } = useWheatCodesService()
    const q = useQuery({
      queryKey: ['wheat_codes_attributes'],
      queryFn: () => getWheatCodeAttributes(),
    })
    return { data: q.data }
  },

  useProducts({ currentPage, itemsPerPage }) {
    const { getProducts } = useProductsService()
    const q = useQuery({
      queryKey: ['products_list', currentPage, itemsPerPage, 'wheat'],
      queryFn: () => getProducts({ currentPage, itemsPerPage }),
      retry: false,
    })
    return { data: q.data, isLoading: q.isLoading }
  },

  useCreate() {
    const { createProduct } = useProductsService()
    const m = useMutation(createProduct)
    return (p: TProduct) => m.mutateAsync(p)
  },

  useUpdate() {
    const { updateProduct } = useProductsService()
    const m = useMutation(updateProduct)
    return (p: TProduct) => m.mutateAsync(p)
  },

  useDelete() {
    const { deleteProduct } = useProductsService()
    const m = useMutation(deleteProduct)
    return (id: number) => m.mutateAsync(id)
  },
}
